import {css} from "lit";
import {commonStyles} from "../../common/styles/Common.js";

export const restoreSessionStyles = [commonStyles, css`
	h1 {
		font-size: 32px;
		font-weight: 600;
		line-height: 42px;
		color: #1F1F1F; /** TODO: var **/
		margin-bottom: 16px;
	}

	#view-submitted h1 {
		text-align: center;
	}

	#instructions, pn-labeled-text-input::part(label) {
		font-weight: normal;
		font-size: 14px;
		color: var(--pn-body-text-color);
	}

	#instructions {
		line-height: 20px;
		margin-bottom: 32px;
	}

	pn-labeled-text-input::part(input) {
		padding: 10px 24px;
		border: 1px solid var(--pn-input-border-color);
		border-radius: 11px;
		color: #1F1F1F; /** TODO: var **/
		font-size: 16px;
		margin-top: 10px;
	}

	#btn-group {
		display: flex;
		margin-top: 32px;
		justify-content: flex-end;
		gap: 8px;
	}

	pn-button::part(button) {
		padding: 13px 16px;
		font-size: 14px;
		line-height: 20px;
	}

	#img-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 168px;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
		gap: 11px;
	}

	#img-shadow {
		position: absolute;
		top: calc(100% + 5px);
	}

	#btn-return {
		display: block;
		width: 190px;
		height: 48px;
		margin: 60px auto 0;
	}
`];
